import PropTypes from "prop-types";
import styles from "./ItemThirdParty.module.css";
import { useTranslation } from "react-i18next";

/**
 * View component, An icon to determine if the item is from a third party. 
 */
export function ItemThirdParty({ is3rdParty }) {
const {t} = useTranslation();

return (
  is3rdParty && (
    <div className={styles.container}>
      <span className={styles.thirdParty}>{t("3rd Party")}</span>
    </div>
  )
);
}

ItemThirdParty.propTypes = {
  is3rdParty: PropTypes.bool,
};
